import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Component, OnInit } from '@angular/core';
import { LayoutComponent } from '../layout/layout.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'

  ]
})
export class LoginComponent implements OnInit {

  constructor(private router: Router,
    private msalService: MsalService,
    private layout: LayoutComponent) {
    this.layout.showLoader = false;
    if (this.msalService.instance.getActiveAccount()) {
      this.router.navigate(['/Home']);
    }
  }

  ngOnInit() {
  }

  login() {
    this.layout.login();
  }
}
